// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2LNR-","list":"styles_list__3vrq_"};